import React, {Component} from 'react'
import {connect} from 'react-redux';
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {withRouter} from 'react-router-dom';
import {
  getAdminEmpresa,
  getEmpresas,
  getGestorEmpresa,
  getOperadorEmpresa,
  getPerfisVendedores,
  getVendedorEmpresa,
  PERFIL_ADMIN,
} from '../../security/securityContext';
import Autorizacao, { validaPerfis, podeImprimirBilheteAposEmbarque } from '../../security/Autorizacao';
import selecionarPedido from '../../actions/pedido/selecionarPedido';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarEmpresa from '../../actions/empresa/buscarEmpresaPorId'
import { paisesDDI } from '../../util/constantsUtil';
import buscarUltimosHistoricosPassageiro from '../../actions/pedido/buscarUltimosHistoricosPassageiro';
import ReactTooltip from 'react-tooltip';

class AcoesPedido extends Component {
  preencherValoresFormulario (pedido) {
    const cartao = pedido.formasPagamentoDto.filter(f => f.tipo === 'Cartão');
    const dinheiro = pedido.formasPagamentoDto.filter(f => f.tipo === 'Dinheiro');
    const pix = pedido.formasPagamentoDto.filter(f => f.tipo === 'PIX');

    this.props.changeFieldValue('formGerenciarPedido',
      'valorTotal', pedido.valor);

    if (cartao.length > 0) {
      this.props.changeFieldValue('formGerenciarPedido',
        'idFormaPagamento', cartao[0].idFormaPagamento);

      this.props.changeFieldValue('formGerenciarPedido',
        'numeroComprovante', cartao[0].numeroComprovante);

      this.props.changeFieldValue('formGerenciarPedido',
        'quantidadeParcelas', cartao[0].quantidadeParcelas);

      this.props.changeFieldValue('formGerenciarPedido',
        'valorCartao', cartao[0].valor);

      this.props.changeFieldValue('formGerenciarPedido',
        'urlComprovante', cartao[0].urlComprovante);

      this.props.changeFieldValue('formGerenciarPedido',
        'nomeComprovante', cartao[0].nomeComprovante);

      this.props.changeFieldValue('formGerenciarPedido',
        'arquivo', cartao[0].arquivo);

      this.props.changeFieldValue('formGerenciarPedido',
        'cartao', true);
    }

    if (pix.length > 0) {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'numeroComprovantePIX', pix[0].numeroComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'valorPIX', pix[0].valor);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'urlComprovantePIX', pix[0].urlComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'nomeComprovantePIX', pix[0].nomeComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'arquivoPIX', pix[0].arquivo);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'pix', true);
    }

    if (dinheiro.length > 0) {
      this.props.changeFieldValue('formGerenciarPedido',
        'idFormaPagamento', dinheiro[0].idFormaPagamento);

      this.props.changeFieldValue('formGerenciarPedido',
        'valorDinheiro', dinheiro[0].valor);

      this.props.changeFieldValue('formGerenciarPedido',
        'dinheiro', true);
    }
  }

  preencherValoresFormularioIncluirFormaPagamento (pedido) {
    this.alterarEmpresaSelecionadaSeNecessario();
    const cartao = pedido.formasPagamentoDto.filter(f => f.tipo === 'Cartão');

    this.props.changeFieldValue('formIncluirFormarPagamento',
      'valorTotal', pedido.valor);

    if (cartao.length > 0) {
      this.props.changeFieldValue('formIncluirFormarPagamento',
        'idFormaPagamento', cartao[0].idFormaPagamento);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'numeroComprovante', cartao[0].numeroComprovante);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'quantidadeParcelas', cartao[0].quantidadeParcelas);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'valorCartao', cartao[0].valor);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'urlComprovante', cartao[0].urlComprovante);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'nomeComprovante', cartao[0].nomeComprovante);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'arquivo', cartao[0].arquivo);

      this.props.changeFieldValue('formIncluirFormarPagamento',
        'cartao', true);
    }
  }

  preencherValoresFormularioAlterarFormaPagamento (pedido) {
    const cartao = pedido.formasPagamentoDto.filter(f => f.tipo === 'Cartão' || f.tipo === 'Cartão de crédito' || f.tipo === 'Cartão de débito');
    const dinheiro = pedido.formasPagamentoDto.filter(f => f.tipo === 'Dinheiro');
    const pix = pedido.formasPagamentoDto.filter(f => f.tipo === 'PIX');
    const linkPagamento = pedido.formasPagamentoDto.filter(f => f.tipo === 'Link Pagamento');

    this.props.changeFieldValue('formAlterarFormaPagamento',
      'valorTotal', pedido.valor);

    if (cartao.length > 0) {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'numeroComprovante', cartao[0].numeroComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'quantidadeParcelas', cartao[0].quantidadeParcelas);
            
      const valor = cartao[0].valor.toFixed(2).replace('.', ',');
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'valorCartao', valor);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'urlComprovante', cartao[0].urlComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'nomeComprovante', cartao[0].nomeComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'arquivo', cartao[0].arquivo);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'cartao', true);
    }

    if (pix.length > 0) {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'numeroComprovantePIX', pix[0].numeroComprovante);
      
      const valor = pix[0].valor.toFixed(2).replace('.', ',');
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'valorPIX', valor);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'urlComprovantePIX', pix[0].urlComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'nomeComprovantePIX', pix[0].nomeComprovante);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'arquivoPIX', pix[0].arquivo);

      this.props.changeFieldValue('formAlterarFormaPagamento',
        'pix', true);
    }

    if (dinheiro.length > 0) {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'dinheiro', true);

      const valor = dinheiro[0].valor.toFixed(2).replace('.', ',');
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'valorDinheiro', valor);
    }

    if (linkPagamento.length > 0) {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'linkPagamento', true);

      const valor = linkPagamento[0].valor.toFixed(2).replace('.', ',');
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'valorLinkPagamento', valor);
    }
  }

  preencherValoresFormularioAlteracaoPassageiros (pedido) {    
    pedido.reservas.forEach((reserva) => {
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `nomePassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.nome);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `numeroCpfPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.cpfPassageiro);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `dtNascimentoPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.dtNascimento);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `numeroDocumentoFoto${reserva.passageiroDto.id}`, reserva.passageiroDto.documentoComFoto);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `telefone${reserva.passageiroDto.id}`, reserva.passageiroDto.telefone);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `nisPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.nis);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `validadeNisPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.validade);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `matriculaPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.matricula);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `rendaPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.renda);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `numeroDeficientePassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.numeroDeficiente);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `validade${reserva.passageiroDto.id}`, reserva.passageiroDto.validade);
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `cargoProfissaoPassageiro${reserva.passageiroDto.id}`, reserva.passageiroDto.cargoProfissao);      
      const pais = paisesDDI.find(it => it.sigla === reserva.passageiroDto.siglaPais)
      const labelPais = {label: `${pais.pais} ${pais.ddi}`, value: pais.id}
      this.props.adicionarValoresDdiPassageiro(reserva.passageiroDto.id, labelPais)
      this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
        `ddi${reserva.passageiroDto.id}`, labelPais);
      if (reserva.passageiroDto.criancaDto) {
        this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
          `nomeCrianca${reserva.passageiroDto.id}`, reserva.passageiroDto.criancaDto.nome);
        this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
          `cpfCrianca${reserva.passageiroDto.id}`, reserva.passageiroDto.criancaDto.cpfCrianca);
        this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
          `dtNascimentoCrianca${reserva.passageiroDto.id}`, reserva.passageiroDto.criancaDto.dtNascimentoCrianca);
        this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
          `documentoCriancaFoto${reserva.passageiroDto.id}`, reserva.passageiroDto.criancaDto.documentoCriacaComFoto);
        this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
          `criancaColo${reserva.passageiroDto.id}`, true);          
      }
    })
  }

  exibirAlteracaoFormaPagamento () {
    if (this.props.pedido.sePodeAlterarFormaPagamento) {
      return (<a className="vx-gp-dropdown-item" data-toggle="modal" data-target="#modalAlterarFormaPagamento"
                 onClick={() => {
                   this.props.selecionarPedido(this.props.pedido);
                   this.preencherValoresFormularioAlterarFormaPagamento(this.props.pedido)
                 }}>
        <span className="material-icons">payment</span>
        Alterar forma de pagamento
      </a>)
    }
    return ''
  }

  exibirHistoricoPassageiro() {
    return (<a className="vx-gp-dropdown-item" data-toggle="modal" data-target="#modalHistoricoPassageiro"
                 onClick={() => {
                   this.props.selecionarPedido(this.props.pedido);
                  this.props.buscarUltimosHistoricosPassageiro(this.props.pedido.id, this.props.pedido.idEmpresa);
                 }}>
      <span className="material-icons">person</span>
      Histórico Passageiro
    </a>)
  }

  exibirInformacoesPagamento () {
    if (this.props.pedido.sePodeRealizaPagamentoPOS) {
      return (<a className="vx-gp-dropdown-item" data-toggle="modal" data-target="#modalRealizarPagamentoPendente"
                 onClick={() =>this.props.selecionarPedido(this.props.pedido)}>
        <span className="material-icons">attach_money</span>
        Realizar pagamento pendente
      </a>)
    }
    return ''
  }

  exibirCancelarEnvioStoneConnect () {
    if (this.props.pedido.sePodeCancelarEnvioStoneConnect) {
      return (<a className="vx-gp-dropdown-item" data-toggle="modal" data-target="#modalCancelarEnvioStoneConnect"
                 onClick={() => this.props.selecionarPedido(this.props.pedido)}>
        <span className="material-icons">cancel</span>
        Cancelar envio Stone Connect
        <a data-tip data-for="tt-cancelar-envio-stone-connect" style={{ marginLeft: 6 }}>
          <span className="material-icons" style={{ color: '#888', fontSize: 16, verticalAlign: 'middle' }}>help</span>
        </a>
        <ReactTooltip className="tooltip-ut" id="tt-cancelar-envio-stone-connect" type="dark" effect="solid">
          <div style={{ maxWidth: 260 }}>
            Cancela o envio à maquininha enquanto o pagamento ainda não foi confirmado. Isso NÃO
            cancela e NÃO estorna automaticamente as cobranças que já foram capturadas e aprovadas.
          </div>
        </ReactTooltip>
      </a>)
    }
    return ''
  }

  exibirAlteracaoDadosPassageiro () {
    if (this.props.pedido.sePodeAlterarPassageiros) {
      return (<a className="vx-gp-dropdown-item" data-toggle="modal" data-target="#modalAlterarDadosPassageiro"
                 onClick={() => {
                   this.props.limparValoresDdiPassageiro();
                   this.alterarEmpresaSelecionadaSeNecessario(this.props.pedido)
                   this.props.selecionarPedido(this.props.pedido);
                   this.preencherValoresFormularioAlteracaoPassageiros(this.props.pedido)
                 }}>
        <span className="material-icons">edit</span>
        Alterar dados de passageiros
      </a>)
    }
  }

  alterarEmpresaSelecionadaSeNecessario(pedido, url){
    if (pedido && pedido.idEmpresa !== this.props.empresaSelecionada.id) {
      const empresas = getEmpresas();
      let empresa = empresas.filter(empresa => empresa.id == this.props.pedido.idEmpresa)[0]
      if(validaPerfis([PERFIL_ADMIN])) {
        this.buscarEAlterarParaEmpresaDoPedido(url);
      } else {
        this.props.alterarEmpresaSelecionada(empresa);
        if(url) {
          this.props.history.push(url)
        }
      }
    } else if(url){
      this.props.history.push(url)
    }
  }

  buscarEAlterarParaEmpresaDoPedido(url) {
    this.props.buscarEmpresa(this.props.pedido.idEmpresa).then(
        response => {
          const empresa = response.payload.data
          this.props.alterarEmpresaSelecionada(empresa);
          if (url) {
            this.props.history.push(url)
          }
        }
    )
  }

  exibirImprimirCupom () {
    const exibir = this.props.pedido.reservas
        .filter(r => r.situacaoReserva === 'APROVADO' &&
          (r.dataHoraEmbarque === null || podeImprimirBilheteAposEmbarque(this.props.empresaSelecionada.id))
        ).length > 0

    if (this.props.pedido.ultimoHistorico.situacaoPedido !== 'CANCELADO' && exibir) {
      const url = `/recibo-passagem?pedido=${this.props.pedido.id}&paginaRetorno=${this.props.history.location.pathname}`;
      return (
        <a className="vx-gp-dropdown-item"
           onClick={() => { this.alterarEmpresaSelecionadaSeNecessario(this.props.pedido, url) }}>
          <span className="material-icons">receipt</span>
          Emitir Cupom
        </a>
      )
    }
  }

  exibirIncluirComprovante () {
    if (this.props.pedido.sePodeAlterarFormaPagamento) {
      const cartao = this.props.pedido.formasPagamentoDto.filter(f => f.tipo === 'Cartão');
      if (cartao.length > 0) {
        return (<a className="vx-gp-dropdown-item" data-toggle="modal" data-target="#modalInformarComprovantePagamento"
                   onClick={() => {
                     this.alterarEmpresaSelecionadaSeNecessario(this.props.pedido)
                     this.props.selecionarPedido(this.props.pedido);
                     this.preencherValoresFormularioIncluirFormaPagamento(this.props.pedido)
                   }}>
          <span className="material-icons">attach_file</span>
          Incluir comprovante
        </a>)
      }
    }
    return ''
  }


  exibirBotaoHistoricoPedido () {
    return (<a className="vx-gp-dropdown-item" data-toggle="modal"
               data-target="#modalHistoricoPedido" onClick={() => {
                 this.alterarEmpresaSelecionadaSeNecessario(this.props.pedido)
                 this.props.selecionarPedido(this.props.pedido)
               }}>
      <span className="material-icons">history</span>
      Histórico do Pedido
    </a>)
  }

  render () {
    return (
        <div className="dropdown">
          <button className="vx-gp-action-btn" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span className="material-icons">more_vert</span>
          </button>
          <div className="dropdown-menu dropdown-menu-right vx-gp-dropdown-menu" aria-labelledby="dropdownMenuButton">
            <Autorizacao
              perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getVendedorEmpresa(this.props.empresaSelecionada.id)
              ]}>
              {this.exibirAlteracaoFormaPagamento()}
              {this.exibirHistoricoPassageiro()}
            </Autorizacao>
            {this.exibirBotaoHistoricoPedido()}
            <div className="vx-gp-dropdown-divider"/>
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
              getGestorEmpresa(this.props.empresaSelecionada.id),
              getAdminEmpresa(this.props.empresaSelecionada.id),
              getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
            ]}>
              {this.exibirIncluirComprovante()}
              {this.exibirAlteracaoDadosPassageiro()}
              {this.exibirInformacoesPagamento()}
              {this.exibirCancelarEnvioStoneConnect()}
            </Autorizacao>
            {validaPerfis([PERFIL_ADMIN]) || !this.props.usuarioBloqueadoEdicaoReimpressaoCupom.habilitadoBloqueioReimpressaoCupom ? this.exibirImprimirCupom() : ''}
          </div>
        </div>
    )
  }
}

const mapStateToProps = state => ({
  usuarioBloqueadoEdicaoReimpressaoCupom: state.usuarioBloqueadoEdicaoReimpressaoCupom || {},
});

export default withRouter(connect(mapStateToProps, {
  changeFieldValue,
  selecionarPedido,
  alterarEmpresaSelecionada,
  buscarEmpresa,
  buscarUltimosHistoricosPassageiro
})(reduxForm({
  form: 'formGerenciarPedido'
})(AcoesPedido)))
